import { LockOutline } from '@mui/icons-material';
import { Stack, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ButtonWithLoader } from 'shared/components';

import { useCandidateAuth } from '../AuthProvider';
import { LoginHelpSection } from './LoginHelp';

interface SignInToContinueProps {
    variant?: 'continue' | 'firstTime';
}

export default function SignInToContinue({ variant = 'continue' }: SignInToContinueProps) {
    const translationKey = variant === 'firstTime' ? 'signInAccessPortal' : 'signInToGetFullAccess';
    const { t } = useTranslation('auth', { keyPrefix: translationKey });
    const { login, isAuthenticated, status } = useCandidateAuth();
    const showInvitationNotice = variant === 'firstTime';

    if (isAuthenticated) {
        return null;
    }

    return (
        <Root>
            <IconWrapper>
                <LockOutline />
            </IconWrapper>

            <Typography variant="h6">
                { t('title') }
            </Typography>

            <Typography variant="body2"
                align="center"
            >
                { t('description') }
            </Typography>

            <ButtonWithLoader variant="contained"
                color="secondary"
                onClick={ () => login() }
                loading={ status === 'pending' }
            >
                { t('button') }
            </ButtonWithLoader>

            { showInvitationNotice ? (
                <LoginHelpSection />
            ) : (
                <Typography variant="caption"
                    color="textSecondary"
                >
                    { t('consent') }
                </Typography>
            ) }
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    rowGap: theme.spacing(4)
}));

const IconWrapper = styled('div')(({ theme }) => ({
    borderRadius: '50%',
    borderColor: theme.palette.divider,
    borderWidth: 1,
    borderStyle: 'solid',
    lineHeight: 0,
    padding: theme.spacing(3),

    svg: {
        fill: theme.palette.secondary.main
    }
}));
